import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "intro-y flex items-center justify-between w-full h-10 my-3 xl:my-5" }
const _hoisted_2 = { class: "text-lg font-medium truncate mr-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "hidden md:block" }, "Reload Data", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RefreshCcwIcon = _resolveComponent("RefreshCcwIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.pageTitle), 1),
    (_ctx.withReloadButton)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: "javascript:;",
          class: "ml-auto flex text-theme-1 dark:text-theme-10",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.actionReloadButton && _ctx.actionReloadButton(...args)))
        }, [
          _createVNode(_component_RefreshCcwIcon, { class: "w-4 h-4 mr-3" }),
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "right-page-title")
  ]))
}